module.exports = require("animejs");